var CAMPAINGS_SETTINGS = {
  "apiUrl": 'eligible-promotions/{vsin}',
  "general": {
    "limits": {
      "productDetailsCard": 4,
      "productFixedBar": 1
    }
  },
  "campaign": {
    "promotion": {
      "percentOff": {
        "sort": 4,
        "icon": {
          "name": "cart-outline",
          "color": "primary",
          "options": {}
        },
        "container": {
          "classes": "",
          "style": "background-color: rgba(201,62,99,0.1)"
        },
        "title": {
          "classes": "font-weight-bold",
          "style": {}
        },
        "callOutMessage": {
          "classes": "text-muted",
          "style": {}
        },
        "endDate": {
          "show": true,
          "icon": {
            "name": "alarm-clock",
            "color": "white",
            "options": {}
          },
          "classes": "badge badge-turquoise badge-pill font-size-sm",
          "style": "background-color: #5654AA"
        },
        "remaining": {
          "show": true,
          "icon": {
            "name": "fire",
            "color": "white",
            "options": {}
          },
          "classes": "badge badge-danger badge-pill font-size-sm",
          "style": "background-color: #E85848"
        },
        "amount": {
          "classes": "super",
          "style": {}
        },
        "showProducts": {
          "show": true,
          "color": "primary",
          "classes": "py-1 px-2",
          "style": {},
          "options": {
            "small": true,
            "uppercase": true
          }
        }
      },
      "amountOff": {
        "sort": 4,
        "icon": {
          "name": "cart-outline",
          "color": "primary",
          "options": {}
        },
        "container": {
          "classes": "",
          "style": "background-color: rgba(201,62,99,0.1)"
        },
        "title": {
          "classes": "font-weight-bold",
          "style": {}
        },
        "callOutMessage": {
          "classes": "text-muted",
          "style": {}
        },
        "endDate": {
          "show": true,
          "icon": {
            "name": "alarm-clock",
            "color": "white",
            "options": {}
          },
          "classes": "badge badge-turquoise badge-pill font-size-sm",
          "style": "background-color: #5654AA"
        },
        "remaining": {
          "show": true,
          "icon": {
            "name": "fire",
            "color": "white",
            "options": {}
          },
          "classes": "badge badge-danger badge-pill font-size-sm",
          "style": "background-color: #E85848"
        },
        "amount": {
          "classes": "super",
          "style": {}
        },
        "showProducts": {
          "show": true,
          "color": "primary",
          "classes": "py-1 px-2",
          "style": {},
          "options": {
            "small": true,
            "uppercase": true
          }
        }
      },
      "bonus": {
        "sort": 5,
        "icon": {
          "name": "cart-outline",
          "color": "primary",
          "options": {}
        },
        "container": {
          "classes": "",
          "style": "background-color: rgba(201,62,99,0.1)"
        },
        "title": {
          "classes": "font-weight-bold",
          "style": {}
        },
        "callOutMessage": {
          "classes": "text-muted",
          "style": {}
        },
        "endDate": {
          "show": true,
          "icon": {
            "name": "alarm-clock",
            "color": "white",
            "options": {}
          },
          "classes": "badge badge-turquoise badge-pill font-size-sm",
          "style": "background-color: #5654AA"
        },
        "remaining": {
          "show": true,
          "icon": {
            "name": "fire",
            "color": "white",
            "options": {}
          },
          "classes": "badge badge-danger badge-pill font-size-sm",
          "style": "background-color: #E85848"
        },
        "amount": {
          "classes": "super",
          "style": {}
        },
        "showProducts": {
          "show": true,
          "color": "primary",
          "classes": "py-1 px-2",
          "style": {},
          "options": {
            "small": true,
            "uppercase": true
          }
        }
      },
      "fixedPrice": {
        "sort": 2,
        "icon": {
          "name": "cart-outline",
          "color": "primary",
          "options": {}
        },
        "container": {
          "classes": "",
          "style": "background-color: rgba(201,62,99,0.1)"
        },
        "title": {
          "classes": "font-weight-bold",
          "style": {}
        },
        "callOutMessage": {
          "classes": "text-muted",
          "style": {}
        },
        "endDate": {
          "show": true,
          "icon": {
            "name": "alarm-clock",
            "color": "white",
            "options": {}
          },
          "classes": "badge badge-turquoise badge-pill font-size-sm",
          "style": "background-color: #5654AA"
        },
        "remaining": {
          "show": true,
          "icon": {
            "name": "fire",
            "color": "white",
            "options": {}
          },
          "classes": "badge badge-danger badge-pill font-size-sm",
          "style": "background-color: #E85848"
        },
        "amount": {
          "classes": "super",
          "style": {}
        },
        "showProducts": {
          "show": false,
          "color": "primary",
          "classes": "py-1 px-2",
          "style": {},
          "options": {
            "small": true,
            "uppercase": true
          }
        }
      }
    }
  }
};
var CAMPAINGS_SELECTOR = null;
var CAMPAINGS_CONTAINER_SELECTOR = null;
var CAMPAIGNS_ADD_TO_CART_SELECTOR = null;
var CAMPAIGNS_FIXED_BAR_SELECTOR = null;
var CAMPAINGS = [];

var PRODUCT_VSIN = null;

function reOrderCampaigns(campaigns) {
  var limits = CAMPAINGS_SETTINGS.general.limits.productDetailsCard;

  campaigns = campaigns
    .map(function (campaign) {
      var isPriority = campaign.basketPrice && campaign.basketPrice > 0;

      campaign.isPriority = isPriority;
      campaign.sort = isPriority ? 1 : CAMPAINGS_SETTINGS.campaign.promotion[campaign.discountType].sort;
    
    return campaign;
  }).sort(function (a, b) {
    return a.sort - b.sort;
  });

  if (limits > -1) {
    campaigns = campaigns.slice(0, limits);
  }

  return campaigns;
};

function getCampaigns(vsin) {
  var apiBaseUrl = '';

  switch(window.CAMPAIGNS_ENV) {
    case 'production':
      apiBaseUrl = 'https://api.vivense.com/';
    break;
    case 'staging':
      apiBaseUrl = 'https://api-staging.vivense.com/';
    break;
    case 'sandbox':
      apiBaseUrl = 'https://api-sandbox.vivense.com/';
    break;
    case 'test':
    default:
      apiBaseUrl = 'https://api-test.vivense.com/';
    break;
  }

  $.ajax({
    type: 'GET',
    url: apiBaseUrl + CAMPAINGS_SETTINGS.apiUrl.replace('{vsin}', vsin),
    success: function (response) {
        var campaigns = response && response.items && Array.isArray(response.items) && response.items.length > 0 ? response.items[0] : null;
        var promotions = campaigns && campaigns.promotions ? campaigns.promotions : [];

        if(promotions.length > 0)
        {
          setCampaigns(promotions);
          CAMPAINGS_SELECTOR.show();
        }
    }
  });
};

function getCampaignCardEndDateHtml(campaign, campaignSettings) {
  var endDateHtml = '';
  var endDateSettings = campaignSettings.endDate;

  if(endDateSettings.show) {
    var startDate = new Date(campaign.endDate);   
    var endDate = new Date();

    var endDateValue = '';

    var diff = startDate.getTime() - endDate.getTime();   
    var remaningHours = diff / (1000 * 60 * 60);
    
    if(remaningHours > 0 && remaningHours < 72) {
      endDateValue = Math.ceil(remaningHours / 24) + ' gün';
    }

    if(endDateValue)
    {
      endDateHtml = (
        '<div class="product-campaigns__enddate '+endDateSettings.classes+'" style="'+endDateSettings.style+'">' + 
          '<img src="https://img.vivense.com/original/images/ea79fd8a2e5e45859ff640144bb32252.svg" />' + 
          '<span>' + endDateValue + '</span>' +
        '</div>'
      );
    }
  }

  return endDateHtml;
};

function getCampaignCardRemaningHtml(campaign, campaignSettings) {
  var remaningHtml = '';
  var remaningSettings = campaignSettings.remaining;
  var remainingBudget = parseInt(campaign.remainingBudget);

  if(remaningSettings.show && remainingBudget > 0 && remainingBudget <= 20) {
    remaningHtml = (
      '<div class="product-campaigns__remaining '+remaningSettings.classes+'" style="'+remaningSettings.style+'">' + 
        '<img src="https://img.vivense.com/original/images/a63bed690a2349179a81cc063a767630.svg" />' + 
        '<span>Son ' + remainingBudget + '</span>' +
      '</div>'
    );
  }

  return remaningHtml;
};

function getCampaignCardAmountHtml(campaign, campaignSettings) {
  var amountHtml = '';
  var amountSettings = campaignSettings.amount;
  var amount = parseInt(campaign.amount);
  var basketPrice = campaign.basketPrice && campaign.basketPrice > 0 ? campaign.basketPrice : 0;
  var value = null;

  var staticDetailText = 'Senin için en avantajlı promosyonu sistem sepette otomatik seçer. Başka bir promosyon daha avantajlı ise bu fiyat sepette uygulanmayabilir.';

  if(basketPrice > 0) {
    if(campaign.showPrice) {
      value = parseInt(campaign.basketPrice).toLocaleString('tr-TR') + ' TL';
    } else if(campaign.discountType === 'percentOff') {
      value = '%' + parseInt(amount) + ' İndirim';
    } else if(campaign.discountType === 'amountOff') {
      value = parseInt(amount).toLocaleString('tr-TR') + 'TL İndirim';
    }
  }

  if(value) {
    amountHtml = (
      '<div class="product-campaigns__amount '+amountSettings.classes+'">' + 
        '<span>Sepette: <strong>' + value + '</strong></span>' +
        '<div class="tooltip-feature" style="cursor:pointer;margin-left:5px;">' + 
          '<img src="https://img.vivense.com/original/images/dac936dcfd40437ca042efc52b32ab0e.svg" class="product-campaigns__icon" />' + 
          '<span class="tooltiptext">'+staticDetailText+'</span>' + 
        '</div>' + 
      '</div>'
    );
  }

  return amountHtml;
};

function setCampaigns(campaigns) {
  CAMPAINGS_CONTAINER_SELECTOR.html('');
 
  campaigns = reOrderCampaigns(campaigns);

  campaigns.forEach(function (campaign, index) {
    var campaignSettings = CAMPAINGS_SETTINGS.campaign.promotion[campaign.discountType];

    var campaignEndDateHtml = getCampaignCardEndDateHtml(campaign, campaignSettings);
    var campaignAmountHtml = getCampaignCardAmountHtml(campaign, campaignSettings);
    var campaignRemainingHtml = getCampaignCardRemaningHtml(campaign, campaignSettings);

    if(index === 0 && CAMPAIGNS_ADD_TO_CART_SELECTOR.length > 0) {
      CAMPAIGNS_ADD_TO_CART_SELECTOR.html('');
      CAMPAIGNS_ADD_TO_CART_SELECTOR.append(
        '<div class="product-campaigns__card '+campaignSettings.container.classes+'" style="margin:0 15px 15px; '+campaignSettings.container.style+'">' +
          '<div class="row">' +
            '<div class="col-xs-12">' +
              '<div class="product-campaigns__header">' +              
                '<div class="product-campaigns__title">'+campaign.name+'</div>' + 
              '</div>' +
            '</div>' +
          '</div>' +
  
          '<div class="row" style="margin-top:5px">' +
            '<div class="col-xs-12">' +
            (campaign.isPriority ? '' : '<div class="product-campaigns__detail">'+campaign.detail+'</div>') + 
              campaignAmountHtml +
            '</div>' +
          '</div>' +
        '</div>'
      );
    }

    if(index === 0 && campaign.isPriority && CAMPAIGNS_FIXED_BAR_SELECTOR.length > 0) {
      CAMPAIGNS_FIXED_BAR_SELECTOR.html('');
      CAMPAIGNS_FIXED_BAR_SELECTOR.append(campaignAmountHtml);
      CAMPAIGNS_FIXED_BAR_SELECTOR.show();
    }
    
    CAMPAINGS_CONTAINER_SELECTOR.append(
      '<div class="product-campaigns__card '+campaignSettings.container.classes+'" style="'+campaignSettings.container.style+'">' +
        '<div class="row">' +
          '<div class="'+(campaignEndDateHtml ? 'col-xs-9' : 'col-xs-12')+'">' +
            '<div class="product-campaigns__header">' +              
              '<img src="https://img.vivense.com/original/images/a13a20fa639840bcb59632285f11d900.svg" class="product-campaigns__icon" />' + 
              '<div class="product-campaigns__title">'+campaign.name+'</div>' + 
            '</div>' +
          '</div>' +
          (campaignEndDateHtml ? '<div class="col-xs-3 text-right">' + campaignEndDateHtml + '</div>' : '') +
        '</div>' +

        '<div class="row" style="margin-top:5px">' +
          '<div class="'+(campaignRemainingHtml ? 'col-xs-9' : 'col-xs-12')+'">' +
            '<div class="product-campaigns__detail">'+campaign.detail+'</div>' + 
            campaignAmountHtml +
          '</div>' +
          (campaignRemainingHtml ? '<div class="col-xs-3 text-right">' + campaignRemainingHtml + '</div>' : '') +
        '</div>' +
      '</div>'
    );
  });
}

$(document).ready(function () {
  CAMPAINGS_SELECTOR = $('#product-campaigns');
  CAMPAINGS_CONTAINER_SELECTOR = $('#product-campaigns__container');
  CAMPAIGNS_ADD_TO_CART_SELECTOR = $('#product-add-to-card-campaigns');
  CAMPAIGNS_FIXED_BAR_SELECTOR = $('#product-fixed-bar-campaigns');
  PRODUCT_VSIN = CAMPAINGS_SELECTOR.data('product-sku');

  if(CAMPAINGS_SELECTOR.length > 0 && CAMPAINGS_CONTAINER_SELECTOR.length > 0 && PRODUCT_VSIN)
  {
    CAMPAINGS_SELECTOR.hide();
    getCampaigns(PRODUCT_VSIN);
  } else {
    console.warn('Campaigns not found.')
  }
});